import yup from '@/plugins/yup'
import { i18n } from '@/plugins/i18n'

const { t } = i18n.global

const ForgotPasswordSchema = yup.object({
  email: yup
    .string()
    .required(t('errors.required', { label: t('views.forgot_password.label.email') }))
    .email(t('errors.invalid', { label: t('views.forgot_password.label.email') }))
    .label(t('views.forgot_password.label.email')),
})

export default ForgotPasswordSchema
